import { render, staticRenderFns } from "./SafariNotificationModal.vue?vue&type=template&id=b96372ae&scoped=true"
import script from "./SafariNotificationModal.vue?vue&type=script&lang=js"
export * from "./SafariNotificationModal.vue?vue&type=script&lang=js"
import style0 from "./SafariNotificationModal.vue?vue&type=style&index=0&id=b96372ae&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96372ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b96372ae')) {
      api.createRecord('b96372ae', component.options)
    } else {
      api.reload('b96372ae', component.options)
    }
    module.hot.accept("./SafariNotificationModal.vue?vue&type=template&id=b96372ae&scoped=true", function () {
      api.rerender('b96372ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/SafariNotificationModal.vue"
export default component.exports